import { call, put, takeLatest } from 'redux-saga/effects'

import { dynamicSort } from 'helpers/utils'
import { fetchFaqs, fetchFaqCategories } from './actions'
import { FETCH_FAQS, FETCH_FAQ_CATEGORIES } from './constants'
import { apiFetchFaqs, apiFetchCategories } from './services'
import arrayToTree from 'array-to-tree'

function* fetchFaqWorker(action) {
  const response = yield call(apiFetchFaqs, action.categoryId, action.deviceId)

  if (response) {
    yield put(fetchFaqs.success(response))
  }
}

function* fetchCategoriesWorker(action) {
  const response = yield call(apiFetchCategories, action.deviceId)

  if (response) {
    const tree = arrayToTree(response, {
      parentProperty: 'parent_category_fk',
      customID: 'PK'
    })

    yield put(fetchFaqCategories.success(tree.sort(dynamicSort('name'))))
  }
}

export default function* watcher() {
  yield takeLatest(FETCH_FAQS.REQUEST, fetchFaqWorker)
  yield takeLatest(FETCH_FAQ_CATEGORIES.REQUEST, fetchCategoriesWorker)
}
